import { FCC } from "types";

import { Button } from "@/components/Interface/Button/Button";
import { ButtonGroupFlexBox } from "@/components/Layout/ButtonGroupFlexBox/ButtonGroupFlexBox";

type ConfirmationButtonGroupProps = {
  disableSuccessButton?: boolean;
  successText: string;
  successAction?: () => void;
  submitAsSuccess?: boolean;
  cancelText: string;
  cancelAction: () => void;
};

export const ConfirmationButtonGroup: FCC<ConfirmationButtonGroupProps> = ({
  disableSuccessButton = false,
  successText,
  successAction,
  cancelText,
  cancelAction,
}) => {
  return (
    <ButtonGroupFlexBox
      primaryButton={
        <Button
          dataTestid="success-button"
          className="accent"
          disabled={disableSuccessButton}
          onClick={successAction}
        >
          {successText}
        </Button>
      }
      secondaryButton={
        <Button
          dataTestid="cancel-button"
          className="accent inverted"
          aria-label="Cancel the current action"
          onClick={() => cancelAction()}
        >
          {cancelText}
        </Button>
      }
    />
  );
};
